export function moveSelectingRangeComponentsToSelectedRangeComponents(scene) {
    scene.selectingRangeComponents.forEach(((rangeComponent, key) => {
        var _a;
        scene.selectedRangeComponents.get(key) && (scene.selectingRangeComponents.get(key).rect.delete(), 
        null === (_a = scene.selectingRangeComponents.get(key).fillhandle) || void 0 === _a || _a.delete()), 
        scene.selectedRangeComponents.set(key, rangeComponent);
    })), scene.selectingRangeComponents = new Map, scene.updateNextFrame();
}
//# sourceMappingURL=move-select-border.js.map
